<div class="recommend-page" @click="closeHallDropdown">
  <div class="page-header">
    <div>
      <h2>推荐祠堂</h2>
      <p>管理平台首页推荐的祠堂，取消推荐请调用 save 并传 state: 0。</p>
    </div>
    <button type="button" class="primary-btn" :disabled="loading || saving" @click="openCreateModal">
      添加推荐
    </button>
  </div>

  <div class="filter-panel">
    <label class="filter-item">
      <span>推荐状态</span>
      <select v-model="filterState" :disabled="loading" @change="handleStateFilterChange">
        <option value="">全部</option>
        <option value="1">推荐中</option>
        <option value="0">已取消</option>
      </select>
    </label>
    <button type="button" class="secondary-btn" :disabled="loading" @click="resetFilters">重置</button>
  </div>

  <div class="table-container">
    <div v-if="loading" class="loading-wrapper">
      <div class="loading-spinner"></div>
      <span>加载中...</span>
    </div>

    <div v-else class="table-scroll">
      <table class="data-table">
        <thead>
          <tr>
            <th class="cover-col">封面</th>
            <th>记录 ID</th>
            <th>祠堂 ID</th>
            <th>祠堂名称</th>
            <th>别称</th>
            <th>姓氏</th>
            <th>成员数</th>
            <th>状态</th>
            <th>更新时间</th>
            <th class="action-col">操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="recommendList.length === 0">
            <td colspan="10" class="empty-text">暂无推荐祠堂</td>
          </tr>
          <tr v-else v-for="item in recommendList" :key="item.id">
            <td class="cover-col">
              <img v-if="pickHallCover(item)" :src="pickHallCover(item)" class="cover-thumb" alt="" />
              <span v-else class="cover-placeholder">无</span>
            </td>
            <td>{{ item.id }}</td>
            <td>{{ pickHallId(item) }}</td>
            <td>{{ pickHallName(item) }}</td>
            <td>{{ pickHallAlias(item) }}</td>
            <td>{{ pickHallSurname(item) }}</td>
            <td>{{ pickHallMemberCount(item) }}</td>
            <td>
              <span :class="item.state === 1 ? 'state-active' : 'state-cancelled'">
                {{ pickStateLabel(item.state) }}
              </span>
            </td>
            <td>{{ formatDate(item.updated_at || item.created_at) }}</td>
            <td class="action-col">
              <button
                v-if="item.state === 1"
                type="button"
                class="action-btn cancel-btn"
                :disabled="saving"
                @click="handleToggleState(item, 0)"
              >
                取消推荐
              </button>
              <button
                v-else
                type="button"
                class="action-btn edit-btn"
                :disabled="saving"
                @click="handleToggleState(item, 1)"
              >
                重新推荐
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-if="!loading && recommendList.length > 0" class="pagination">
      <button type="button" class="page-btn" :disabled="currentPage <= 1" @click="handlePageChange(currentPage - 1)">
        上一页
      </button>
      <span class="page-info">第 {{ currentPage }} / {{ totalPages }} 页 · 共 {{ total }} 条</span>
      <button
        type="button"
        class="page-btn"
        :disabled="currentPage >= totalPages"
        @click="handlePageChange(currentPage + 1)"
      >
        下一页
      </button>
    </div>
  </div>

  <div v-if="modalVisible" class="modal-mask" @click="closeModal">
    <div class="modal-panel" @click.stop @click="closeHallDropdown">
      <div class="modal-header">
        <h3>添加推荐祠堂</h3>
        <button type="button" class="close-btn" @click="closeModal">×</button>
      </div>
      <div class="modal-body">
        <label class="form-row" @click.stop>
          <span>搜索祠堂 <em>*</em></span>
          <div class="search-picker">
            <input
              v-model="hallSearchQuery"
              type="search"
              placeholder="输入祠堂名称、姓氏等搜索"
              autocomplete="off"
              @input="handleHallSearch"
              @focus="hallDropdownOpen = true"
            />
            <button v-if="selectedHall" type="button" class="clear-btn" @click="clearSelectedHall">清除</button>
            <div
              v-if="hallDropdownOpen && (hallSearchLoading || hallSearchResults.length > 0)"
              class="search-dropdown"
            >
              <div v-if="hallSearchLoading" class="dropdown-hint">搜索中...</div>
              <button
                v-for="hall in hallSearchResults"
                :key="hall.id"
                type="button"
                class="dropdown-item"
                @click="selectHall(hall)"
              >
                {{ hall.hallName || hall.hall_name || hall.name || '未命名' }}（ID: {{ hall.id }}）
              </button>
            </div>
            <div v-if="selectedHall" class="selected-item">
              已选：{{ hallSearchQuery }}（ID: {{ selectedHall.id }}）
            </div>
          </div>
        </label>
      </div>
      <div class="modal-actions">
        <button type="button" class="secondary-btn" :disabled="saving" @click="closeModal">取消</button>
        <button type="button" class="primary-btn" :disabled="saving" @click="handleAddRecommend">
          {{ saving ? '保存中...' : '确认推荐' }}
        </button>
      </div>
    </div>
  </div>
</div>
